const CLICKED_TESTIMONIALS_ARROW = 'Clicked testimonials arrow',
    CLICKED_SUBCATEGORY_ARROW = 'Clicked subcategory arrow',
    CLICKED_POPULAR_SEARCH_TAG = 'Clicked popular search tag',
    CLICKED_BRAND_VIDEO = 'Clicked brand video',
    CLICKED_TESTIMONIALS_VIDEO = 'Clicked testimonials video',
    CLICKED_MARKETING_GUIDE = 'Clicked marketing guide',
    CLICKED_MADE_ON_FIVERR_ARROW = 'Clicked made on fiverr arrow',
    CLICKED_BANNER_SEARCH = 'Clicked banner search',
    MP_SHOW_PAGE_NAME = 'Homepage';

export {
    CLICKED_TESTIMONIALS_ARROW,
    CLICKED_SUBCATEGORY_ARROW,
    CLICKED_POPULAR_SEARCH_TAG,
    CLICKED_BRAND_VIDEO,
    CLICKED_TESTIMONIALS_VIDEO,
    CLICKED_MARKETING_GUIDE,
    CLICKED_MADE_ON_FIVERR_ARROW,
    CLICKED_BANNER_SEARCH,
    MP_SHOW_PAGE_NAME
};
